const ACTIONS = {
    LANGUAGE: "LANGUAGE",
    THEME: "THEME"
};

export default ACTIONS;